export default "__VITE_ASSET__BdRzulzr__"